import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  makeStyles, withStyles, Paper, Grid, Button,
} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { Snackbar } from '@material-ui/core';
import { formatPosition, formatDate } from '../common/formatter';
import RemoveDialog from '../RemoveDialog';
import { getPosition } from '../common/selectors';
import moment from 'moment';
import { api_call, empty, getDeviceDistanceUnit, getDeviceSpeedUnit, getDistanceWithUnit, getSpeedWithUnit, isIphoneDevice, removeItemFromArray } from '../helpers/untils';
import TemporaryUploadModal from './TemporaryUploadModal';
import { DEVICE_TYPE, DEVICE_USAGE_TYPE, MILE_KM_RATE } from '../config/constant';
import GoogleGeolocationAddressBox from '../components/GoogleGeolocationAddressBox';
import DeviceSignalBox from '../components/DeviceSignalBox';
import { useTranslation } from '../LocalizationProvider';
import LanguageSelector from '../components/LanguageSelector';
import { Stack } from '@mui/material';
import TemporaryLogoutButton from './TemporaryLogoutButton';
import { Fragment } from 'react';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '300px',
  },
  ...theme.palette.colors,
  listItemContainer: {
    // maxWidth: '280px',
  },
  controlBtn: {
    background: 'rgba(76, 175, 80, 0.1)',
    border: '2px solid rgba(76, 175, 80, 1)',
    marginBottom: 10,
    // paddingTop: 3,
    // paddingBottom: 3,
  },
  headerBox: {
    paddingRight: 0,
  },
  navButton: {
    border: '2px solid rgba(76, 175, 80, 1)',
  },
  tempStatusViewContainer: {
    '& .MuiListItem-gutters': {
      paddingTop: '6px',
      paddingBottom: '6px',
      paddingLeft: '8px',
      paddingRight: '8px'
    }
  }
}));

const MyListItem = withStyles({
  root: {
    "&$selected": {
      backgroundColor: "rgba(76, 175, 80, 0.2)",
    },
    "&$selected:hover": {
      backgroundColor: "rgba(76, 175, 80, 0.2)",
    },
    "&:hover": {
      backgroundColor: "rgba(76, 175, 80, 0.2)",
    }
  },
  selected: {}
})(ListItem);

const TemporaryStatusView = (props) => {
  const {
    currentLink, loadLinkInfo, deviceId, onShowDetails, onShowHistory, onEditClick, lat, lng, onLogClick, commandsData, userDeviceItem, containerLayout = "map", pageType, isTest = false
  } = props

  const t = useTranslation();
  const classes = useStyles();

  const [removeDialogShown, setRemoveDialogShown] = useState(false);
  const device = useSelector((state) => state.devices.items[deviceId]);
  const position = useSelector(getPosition(deviceId));

  const user = useSelector((state) => state.session.user);
  const currentSharedLink = useSelector((state) => state.layout.currentSharedLink);
  //console.log("currentSharedLink:::", currentSharedLink)

  // Delivery share links only expose the live car location, so the guest popup is
  // trimmed down to Speed / Driven / Direction (no controls, history or addresses).
  const isDeliveryDevice = (() => {
    if (device?.usage_type === DEVICE_USAGE_TYPE.DELIVERY) return true
    // try {
    //   if (currentLink?.share_settings) {
    //     return JSON.parse(currentLink.share_settings)?.usage_type === DEVICE_USAGE_TYPE.DELIVERY
    //   }
    // } catch (e) { /* ignore malformed share_settings */ }
    return false
  })()

  const handleRemoveResult = () => {
    setRemoveDialogShown(false);
  };

  const [commandsDetail, setCommandsDetail] = useState(commandsData);

  useEffect(() => { // whenever changed commands data, update command detail
    setCommandsDetail(commandsData)
  }, [commandsData])

  const handleSendCommand = async () => {
    var url = `/api/temporary/commandsDetail?shareUrl=${currentLink.shareUrl}`;
    const response = await api_call(url);
    if (response.ok) {
      setCommandsDetail(await response.json());
    }
  };

  useEffect(() => {
    handleSendCommand()
  }, []);

  const watchCurrentLinkStatus = async () => {
    if (currentSharedLink && currentSharedLink.share_setting_enabled) {
      let share_settings_obj = null
      if (currentSharedLink.share_settings) {
        share_settings_obj = JSON.parse(currentSharedLink.share_settings)
      }
      let photo_uploads_obj = null
      if (currentSharedLink.photo_uploads) {
        photo_uploads_obj = JSON.parse(currentSharedLink.photo_uploads)
      }
      // console.log("share_settings_obj, photo_uploads_obj:::", share_settings_obj, photo_uploads_obj)
      if (share_settings_obj) {
        if (share_settings_obj.unlock_car) {
          if (share_settings_obj.unlock && share_settings_obj.unlock.length > 0) {
            if (photo_uploads_obj) {
              if (photo_uploads_obj.unlock_approved !== "approved") {
                if (link.unlock_approved !== "denied" && photo_uploads_obj.unlock_approved === "denied") {
                  setUploadType("unlock")
                }
                return false
              }
            }
          }
        }

        if (share_settings_obj.auto_kill_switch) {
          if (share_settings_obj.unkill_car && share_settings_obj.unkill_by !== 'renter') {
            if (share_settings_obj.unkill && share_settings_obj.unkill.length > 0) {
              if (photo_uploads_obj) {
                if (empty(photo_uploads_obj.unkill_approved) || photo_uploads_obj.unkill_approved === 'denied') {
                  setUploadType("unkill")
                  return false
                }
              }
            }
          }
        }
      }
    }
  }

  const [link, setLink] = useState(currentLink)

  useEffect(() => {
    watchCurrentLinkStatus()
    setLink(currentSharedLink)
  }, [currentSharedLink]);

  //////////////////////////////////////////////////////////
  const commandLabels = {
    Unlock: "Unlock",
    Lock: "Lock",
    Horn: "Honk Horn",
  }

  const [commandList, setCommandList] = useState([])
  const initCommandList = async () => {
    const deviceId = device?.id
    if (deviceId) {
      const response = await api_call(`/api/temporary/device-control-menu?shareUrl=${currentLink.shareUrl}`);
      if (response.ok) {
        const data = await response.json()
        setCommandList(data['commandList'])
      } else {
        setCommandList([])
      }
    }
  }

  useEffect(() => {
    initCommandList()
  }, [device?.id])

  const [uploadType, setUploadType] = useState("")

  const [loadingCommands, setLoadingCommands] = useState([])

  const popLoadingCommand = (value) => {
    let loading_commands = [...loadingCommands]
    if (value === 'Horn') {
      setTimeout(() => {
        loading_commands = removeItemFromArray(loading_commands, value)
        //console.log("loading_commands::::", loading_commands)
        setLoadingCommands(loading_commands)
      }, 30 * 1000)
    } else {
      loading_commands = removeItemFromArray(loading_commands, value)
      //console.log("loading_commands::::::::::", loading_commands)
      setLoadingCommands(loading_commands)
    }
  }

  const handleListItemClick = async (value) => {
    let msg = "Sent Command"
    if (loadingCommands.includes(value)) {
      setNotificationMessage("Please try later");
      setNotificationShow(true);
      return false
    }
    setLoadingCommands([...loadingCommands, value]);
    if (value === 'phone_key') {
      let url = `/api/tesla/get-phone-key?deviceId=${device.id}&userId=${currentLink.userId}&shareUrl=${currentLink.shareUrl}`;
      if (currentLink?.reservation_id) {
        url += `&reservation_id=${currentLink?.reservation_id}`;
      }
      const response = await api_call(url);
      if (response.ok) {
        const responseObj = await response.json();
        const invitation_share_link = responseObj.invitation_share_link;
        if (invitation_share_link) {
          window.open(invitation_share_link, '_blank');
        } else {
          alert(`Invalid request`);
        }
      }
      else {
        msg = "Failed trying phone key";
        const errorObj = response;
        if (errorObj && errorObj.error) {
          msg = errorObj.error;
        }
        setNotificationMessage(msg);
        setNotificationShow(true);
      }
      popLoadingCommand(value)
    }
    else {
      let url = `/api/command?command=${value}&shareUrl=${currentLink.shareUrl}`
      if (currentLink?.reservation_id) {
        url += `&reservation_id=${currentLink?.reservation_id}`
      }

      const response = await api_call(url);

      if (response.ok) {
        msg = "Sent Command"
      }
      else {
        popLoadingCommand(value)

        msg = "Failed sending command"
        const errorObj = response
        if (errorObj) {
          if (errorObj.errorType) {
            msg = errorObj.error
            if (errorObj.errorType === 'upload_unlock_approval') {
              setUploadType("unlock")
              return false
            }
            else if (errorObj.errorType === 'upload_unkill_approval') {
              setUploadType("unkill")
              return false
            }
          }
          else if (errorObj.error) {
            msg = errorObj.error
          }
        }
        setNotificationMessage(msg);
        setNotificationShow(true);
        return false
      }

      if (device.deviceType === DEVICE_TYPE.TESLA && value === 'Unlock' && getEnableTeslaPhoneKey() === 'true') {
        handleListItemClick('phone_key');
      }

      await handleSendCommand()
      popLoadingCommand(value)

      //setNotificationMessage(msg);
      //setNotificationShow(true);
    }
  }

  const getDetail = (command) => {
    // var tempCommand = command;
    // if(command === "Kill/Unkill") tempCommand = "Kill";
    for (var key in commandsDetail) {
      if (key === command) {
        if (key === "Overspeed") return commandsDetail[key].count + getDeviceSpeedUnit(device?.distance_unit);
        else if (key === "Geofence") return commandsDetail[key].count + getDeviceDistanceUnit(device?.distance_unit);
        return formatDate(commandsDetail[key].createdAt);
      }
    }
    return false;
  }
  const getStatus = (command) => {
    return commandsDetail[command].status;
  }
  const onClickGoToCar = () => {
    let url = `https://www.google.com/maps/dir/your+location/${device.latitude},${device.longitude}/@${device.latitude},${device.longitude},17z`
    const isIphone = isIphoneDevice();
    console.log(`isIphone::::`, isIphone);
    if (isIphone) {
      // url = `https://maps.apple.com/?q=${device.latitude},${device.longitude}`
      url = `https://maps.apple.com/?daddr=${device.latitude},${device.longitude}`
    }
    console.log(`map url::::`, url);
    window.open(url, '_blank');
  }

  const getEnableTeslaPhoneKey = () => {
    const share_settings = currentLink.share_settings;
    if (share_settings) {
      const share_settings_obj = JSON.parse(share_settings);
      return share_settings_obj['enable_tesla_phone_key'];
    }
  }

  const [notificationShow, setNotificationShow] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");

  return (
    <>
      {
        (
          <div className='status-view-popup' style={{ maxHeight: 'calc(100vh - 165px)', overflowY: 'auto' }}>
            <Paper className={classes.paper} elevation={0} square>
              <Grid container direction="column" className={classes.tempStatusViewContainer}>
                <Grid item>
                  <Stack direction={`row`} justifyContent={`space-between`} style={{ width: '100%', paddingTop: '8px', marginBottom: '-8px' }}>
                    <TemporaryLogoutButton
                      currentLink={currentLink}
                    />
                    <LanguageSelector />
                  </Stack>
                  <List>
                    <ListItem className={classes.headerBox}>
                      <ListItemText primary={device.name} />
                      {
                        (!isDeliveryDevice) && (
                          <Button color="secondary" className={classes.navButton} style={{ minWidth: '115px', marginRight: '-8px' }}
                            onClick={() => onClickGoToCar()}>
                            {t('GoToCar')}
                          </Button>
                        )
                      }
                    </ListItem>

                    <div style={{ display: isDeliveryDevice ? 'none' : 'block' }}>
                      {(!isDeliveryDevice) && (commandsDetail) && commandList.map((commandItem) => {
                        const command = commandItem.CommandName
                        return (
                          <Fragment key={command}>
                            <MyListItem button onClick={() => handleListItemClick(command)} className={classes.controlBtn} disabled={loadingCommands.includes(command)}>
                              <ListItemText primary={<div className='text-center center'>{t(commandItem.CommandLabel)}</div>} />
                              {getDetail(command) &&
                                (
                                  getStatus(command) === 'success' ?
                                    <DoneAllIcon color="secondary" /> :
                                    <CheckIcon color="disabled" />
                                )
                              }
                            </MyListItem>
                            {/* {
                              (device.deviceType === DEVICE_TYPE.TESLA && command === 'Unlock' && link.unlock_timestamp && getEnableTeslaPhoneKey() === 'true') ? (
                                <>
                                  <MyListItem button onClick={() => handleListItemClick('phone_key')} className={classes.controlBtn} disabled={loadingCommands.includes('phone_key')}>
                                    <ListItemText primary={<div className='text-center center'>{t('PHONE KEY')}</div>} />
                                  </MyListItem>
                                </>
                              ) : (
                                <></>
                              )
                            } */}
                          </Fragment>
                        )
                      })}
                    </div>

                    {
                      (!isDeliveryDevice) && (
                        <div>
                          <Grid container>
                            <Grid item>
                              <Button color="secondary" onClick={() => { onShowHistory(deviceId) }}>{t('Replay')}</Button>
                            </Grid>
                          </Grid>
                        </div>
                      )
                    }

                    {
                      (!isDeliveryDevice && device.deviceType === DEVICE_TYPE.MOOVETRAX) ? (
                        <>
                          <ListItem classes={{ container: classes.listItemContainer }}>
                            <ListItemText primary={t('Signal')} />
                            <DeviceSignalBox
                              viewLocation="TemporaryStatusView"
                              device={device}
                            />
                          </ListItem>
                        </>
                      ) : (
                        <></>
                      )
                    }

                    {
                      (!isDeliveryDevice) && (
                        <ListItem classes={{ container: classes.listItemContainer }}>
                          <ListItemText primary={t('LastPosition')} />
                          <>
                            {formatDate(device.lastPosition)}
                          </>
                        </ListItem>
                      )
                    }

                    {
                      (!isDeliveryDevice) && (
                        <ListItem classes={{ container: classes.listItemContainer }}>
                          <ListItemText primary={t('LastConnect')} />
                          <>
                            {formatDate(device.lastConnect)}
                          </>
                        </ListItem>
                      )
                    }

                    {
                      (!isDeliveryDevice) && (
                        <ListItem classes={{ container: classes.listItemContainer }}>
                          {/* <ListItemText primary="Address" /> */}
                          <ListItemSecondaryAction>
                            <div style={{ marginRight: '-8px' }}>
                              <GoogleGeolocationAddressBox
                                lat={lat}
                                lng={lng}
                                label={t('ShowAddress')}
                                shareUrl={currentLink?.shareUrl}
                              />
                            </div>
                          </ListItemSecondaryAction>
                        </ListItem>
                      )
                    }

                    <ListItem classes={{ container: classes.listItemContainer }}>
                      <ListItemText primary={t('Speed')} />
                      {(moment().diff(moment(device.lastPosition), "seconds") < 60) && <>
                        {getSpeedWithUnit(device.speed, device.distance_unit)}
                      </>}
                    </ListItem>
                    <ListItem classes={{ container: classes.listItemContainer }}>
                      <ListItemText primary={t('Driven')} />
                      <>
                        {getDistanceWithUnit(Number(device.odometer) - Number(currentLink.start_odometer) / (device.distance_unit === 'km' ? 1 : MILE_KM_RATE), device.distance_unit)}
                      </>
                    </ListItem>
                    <ListItem classes={{ container: classes.listItemContainer }}>
                      <ListItemText primary={t('Direction')} />
                      <>
                        {t(formatPosition(device.direction, 'direction'))}
                      </>
                    </ListItem>
                    {/* <div className='mt-2'></div> */}
                  </List>
                </Grid>
              </Grid>
            </Paper>
          </div>
        )
      }

      {
        (uploadType !== "") && (
          <>
            <TemporaryUploadModal
              open={uploadType !== ""}
              setOpen={setUploadType}
              link={currentLink}
              type={uploadType}
              loadLinkInfo={loadLinkInfo}
              isTest={isTest}
            />
          </>
        )
      }

      <RemoveDialog open={removeDialogShown} endpoint="devices" itemId={deviceId} onResult={handleRemoveResult} />
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={notificationShow}
        message={notificationMessage}
        autoHideDuration={1500}
        onClose={() => { setNotificationShow(false) }}
      />
    </>
  )
}

export default TemporaryStatusView;
